import React from 'react'
import { Event } from '@/payload-types'
import { GridBlock } from '@/components'

interface EventListProps {
  items: Event[]
}

function EventList({ items }: Readonly<EventListProps>) {
  return (
    <GridBlock
      blockType="grid"
      items={items.map((event) => ({
        relationTo: 'events' as const,
        value: event,
      }))}
    />
  )
}

export { EventList }
